import { el, setAttr } from 'redom';

import './index.scss';

class Sender {

  constructor(senderButton) {

    this.senderButton = senderButton;

    this.picture = el('label.sender-picture');
    this.name = el('label.sender-name');
    this.email = el('label.sender-email.sub-text');

    this.el = el('.sender-option', {
      onclick: this.handleClick.bind(this)
    }, [
      this.picture, el('span', [this.name, ' (', this.email, ')'])
    ]);

  }

  handleClick(event) {

    event.stopPropagation();

    this.senderButton.select(this.sender);

  }

  update(sender) {

    this.sender = sender;

    if (this.sender.profilePicture === void 0) {
      this.picture.textContent = this.sender.fullName.charAt(0);
    } else {
      this.picture.textContent = '';
      setAttr(this.picture, {
        style: {
          'background-image': `url(${this.sender.profilePicture.url})`
        }
      });
    }

    this.name.textContent = this.sender.fullName;
    this.email.textContent = this.sender.email;

    if (this.senderButton.isSelected(this.sender) === true) {
      this.el.classList.add('selected');
    } else {
      this.el.classList.remove('selected');
    }

  }

}

export default Sender;